export const getSONumber = (stringIn: string | null) => {
  if (stringIn && stringIn.length > 4) {
    const tempArray = stringIn.split('');
    return tempArray.slice(4).join('');
  }
  return '';
};
